{
  "common": {
    "close": "Kapat",
    "noRecordsFound": "Kayıt bulunamadı",
    "requiredField": "Bu alan zorunludur"
  },
  "header": {
    "languageLabel": "Dil",
    "logoAlt": "ARPM logosu"
  },
  "toast": {
    "success": "Başarılı",
    "error": "Hata",
    "warning": "Uyarı"
  },
  "create": {
    "heroEyebrow": "Randevu Oluştur",
    "heroTitle": "Randevu Kayıt Sayfası",
    "heroSubtitle": "Uygun tarih ve saat seçerek randevunuzu hızlıca oluşturun.",
    "panelTitle": "Randevu Detayları",
    "panelSubtitle": "Lütfen gerekli seçimleri yapın",
    "organizationLabel": "Organizasyon",
    "facilityLabel": "Tesis",
    "departmentLabel": "Departman",
    "doctorLabel": "Doktor",
    "organizationPlaceholder": "Organizasyon seçin",
    "facilityPlaceholder": "Tesis seçin",
    "departmentPlaceholder": "Departman seçin",
    "doctorPlaceholder": "Doktor seçin",
    "calendarTitle": "Tarih ve saat seçin",
    "timeHeader": "{{date}} için uygun saatler",
    "selectableTimes": "Seçilebilir Saatler",
    "noAvailableTimes": "Uygun saat bulunamadı.",
    "createButton": "Randevuyu Oluştur",
    "toasts": {
      "missingCoreSelection": "Organizasyon, tesis, departman ve doktor seçimi gereklidir.",
      "missingAppointmentSelection": "Lütfen tarih, saat ve doktor seçimini tamamlayın.",
      "unavailableTime": "Seçilen saat artık uygun değil. Lütfen başka bir saat seçin.",
      "invalidDate": "Geçerli bir tarih seçin.",
      "invalidTime": "Geçerli bir saat seçin.",
      "created": "Randevu oluşturuldu.",
      "createdFallback": "Randevu başarıyla oluşturuldu.",
      "createError": "Randevu oluşturulurken hata oluştu."
    }
  },
  "preparation": {
    "heroEyebrow": "Randevu Kayıt",
    "heroTitle": "Randevu Kayıt Formu",
    "heroSubtitle": "Bilgilerinizi eksiksiz doldurun, randevunuzu hızlıca oluşturun.",
    "metaStepByStep": "Adım Adım Kayıt",
    "metaSecureData": "Güvenli Veri",
    "panelTitle": "Bilgileriniz",
    "panelSubtitle": "Lütfen aşağıdaki alanları eksiksiz doldurun",
    "personalInfoTitle": "Kişisel Bilgiler",
    "addressInfoTitle": "Adres Bilgileri",
    "tcLabel": "T.C. Kimlik No",
    "tcPlaceholder": "T.C. Kimlik No",
    "tcRequired": "T.C. Kimlik No zorunludur",
    "tcInvalid": "Lütfen giriş bilgilerinizin doğruluğunu kontrol ediniz.",
    "nameLabel": "Ad",
    "namePlaceholder": "Adınızı girin",
    "lastNameLabel": "Soyad",
    "lastNamePlaceholder": "Soyadınızı girin",
    "birthDateLabel": "Doğum Tarihi",
    "birthDatePlaceholder": "GG/AA/YYYY",
    "genderLabel": "Cinsiyet",
    "male": "Erkek",
    "female": "Kadın",
    "phoneLabel": "Telefon No",
    "phonePlaceholder": "5xx xxx xx xx",
    "emailLabel": "E-posta",
    "emailPlaceholder": "ornek@email.com",
    "emailInvalid": "Geçerli bir e-posta adresi girin",
    "cityLabel": "Şehir",
    "cityPlaceholder": "Şehir seçiniz",
    "districtLabel": "İlçe",
    "districtPlaceholder": "İlçe seçiniz",
    "neighborhoodLabel": "Mahalle",
    "neighborhoodPlaceholder": "Mahalle",
    "streetLabel": "Sokak",
    "streetPlaceholder": "Sokak",
    "buildingNoLabel": "Bina No",
    "buildingNoPlaceholder": "Bina No",
    "apartmentNoLabel": "Daire No",
    "apartmentNoPlaceholder": "Daire No",
    "nextButton": "İleri",
    "checklistTitle": "Hazırlık Kontrolü",
    "checklistSubtitle": "Zorunlu alanları doldurdukça aşağıda işaretlenecek.",
    "checklistEmpty": "Henüz doldurulan zorunlu alan yok.",
    "fieldLabels": {
      "name": "Ad",
      "lastName": "Soyad",
      "tc": "T.C. Kimlik No",
      "birthDate": "Doğum Tarihi",
      "gender": "Cinsiyet",
      "phone": "Telefon No",
      "email": "E-posta",
      "city": "Şehir",
      "district": "İlçe",
      "neighborhood": "Mahalle",
      "street": "Sokak",
      "buildingNo": "Bina No",
      "apartmentNo": "Daire No"
    },
    "invalidEmailLabel": "E-posta (geçersiz)",
    "invalidBirthDateLabel": "Doğum Tarihi (geçersiz)"
  },
  "consent": {
    "title": "Onam Bilgilendirmesi",
    "examination": "Tetkik:",
    "paragraph1": "Doktor asistanımızla birlikte, muayene edilmesini istediğiniz bölgeleri siz belirlersiniz.",
    "paragraph2": "İyi huylu ve kötü huylu lezyonları yüksek tıbbi doğrulukla ayırt edebilen gelişmiş bir sistem kullanıyoruz. Sonuçlar, tele-dermatoloji konusunda uzman dermatologlarımızdan biri tarafından değerlendirilir.",
    "singlePrice": "Bir cilt kanseri taramasının ücreti 22,00 €'dur.",
    "includedTitle": "Bu hizmet kapsamında şunları alırsınız:",
    "items": [
      "Doktor asistanı ile ön görüşme",
      "Şüpheli bir lezyon için cilt kanseri taraması",
      "Dermatoloğumuzdan rapor ve tanı",
      "Cildinizi korumaya yönelik bilgilendirme"
    ],
    "multiplePrice": "Birden fazla cilt kanseri taramasında ücret, ben başına 18,00 €'dur.",
    "absenceTitle": "Gelmediğiniz durumlarda no-show faturası düzenlenir. Aşağıdaki istisnalar geçerlidir:",
    "cancellation48": "Randevudan 48 saat önce yapılan iptallerde ücret alınmaz.",
    "cancellation24": "Randevudan 24 saat önce yapılan iptallerde inceleme başına 15,00 € ücret alınır.",
    "sameDay": "Randevu günü yapılan iptallerde veya haber verilmeden gelinmediğinde inceleme başına 23,50 € ücret alınır."
  },
  "success": {
    "title": "Teşekkürler!",
    "subtitle": "Başvurunuz başarıyla alındı.",
    "message1": "Paylaştığınız iletişim bilgilerine SMS ve e-posta gönderilecektir.",
    "message2": "E-posta ulaşmazsa lütfen spam kutunuzu kontrol edin."
  },
  "departments": {
    "Cardiology": {
      "label": "Kardiyoloji",
      "icon": "noun-cardiology-4072383"
    },
    "Nephrology": {
      "label": "Nefroloji",
      "icon": "noun-nephrology-7030227"
    },
    "Urology": {
      "label": "Üroloji",
      "icon": "kidney"
    },
    "Pulmonology": {
      "label": "Göğüs Hastalıkları",
      "icon": "lung"
    },
    "Neurology": {
      "label": "Nöroloji",
      "icon": "noun-neurology-5594376"
    },
    "Gastroenterology": {
      "label": "Gastroenteroloji",
      "icon": "gastroentology"
    },
    "Endocrinology": {
      "label": "Endokrinoloji",
      "icon": "noun-endocrinology-7357860"
    },
    "Hematology": {
      "label": "Hematoloji",
      "icon": "noun-hematology-7795354"
    },
    "Rheumatology": {
      "label": "Romatoloji",
      "icon": "noun-rheumatology-8059647"
    },
    "Dermatology": {
      "label": "Dermatoloji",
      "icon": "noun-dermatology-6378674"
    },
    "Infectious Diseases": {
      "label": "Enfeksiyon Hastalıkları",
      "icon": "noun-infectious-disease-7245345"
    },
    "Ophthalmology": {
      "label": "Göz Hastalıkları",
      "icon": "noun-ophthalmology-7215358"
    },
    "Otolaryngology": {
      "label": "Kulak Burun Boğaz",
      "icon": "noun-otolaryngology-4840300"
    },
    "Orthopedics": {
      "label": "Ortopedi",
      "icon": "noun-orthopedics-6516988"
    },
    "Psychiatry": {
      "label": "Psikiyatri",
      "icon": "noun-psychology-6565274"
    },
    "Obstetrics Gynecology": {
      "label": "Kadın Hastalıkları ve Doğum",
      "icon": "noun-obstetrics-and-gynecology-1191435"
    },
    "Oncology": {
      "label": "Onkoloji",
      "icon": "noun-oncology-2312680"
    },
    "Transplantation": {
      "label": "Nakil",
      "icon": "noun-transplant-2526273"
    },
    "Home Care": {
      "label": "Evde Sağlık",
      "icon": "noun-home-care-7110960"
    }
  }
}
